<script>
  import { apiFetch } from "../lib/api.js";
  import { user } from "../stores/user"
  import { BASE_URL } from "../stores/BASE_URL"
  import { onMount } from "svelte"
  import { navigate } from "svelte-routing"
  import Navbar from "../components/Navbar.svelte"
  import Alert from "../components/Alert.svelte"
  import CardContent from "../components/CardContent.svelte"

  export let id
  let isSeting = false
  let option_sms = true
  let send_sms = false
  let send_correo = false

  let alert = {
    show: false,
    message: "",
    status: "",
    time: 5000,
  }

  let usuario = {
    usuario: "",
    cliente: "",
    nombres: "",
    inicio: "0001-01-01",
    fin: "0001-01-01",
    consultas: 0,
    consumo: 0,
    estado: "0",
    clave: "",
    celular: "",
  }

  const getDatos = async () => {
    const response = await apiFetch(
      `${BASE_URL}usuario.php?action=getDatos&id=${id}`,
    )
    const resp = await response.json()
    usuario = resp.data

    if (usuario.celular.length == 9) {
      option_sms = false
    }
  }

  const handleSubmit = async () => {
    isSeting = true
    alert.show = false

    if (!validarCaracteres(usuario.clave)) {
      window.alert(
        "La clave debe tener al menos 10 caracteres, incluyendo una letra mayúscula, una letra minúscula, un número y al menos dos caracteres especiales (!*/#%@$_&-)",
      )
      isSeting = false
      return
    }

    const formData = new FormData()
    formData.append("id_usuario", id)
    formData.append("clave", usuario.clave)
    formData.append("sms", send_sms ? "SI" : "NO")
    formData.append("correo", send_correo ? "SI" : "NO")
    formData.append("action", "setClave")
    formData.append("session_id_usuario", $user.idUsuario)
    formData.append("usuario", usuario.usuario)
    const response = await apiFetch(`${BASE_URL}usuario.php`, {
      method: "POST",
      body: formData,
    })
    const resp = await response.json()
    if (resp.status == "success") {
      alert.show = true
      alert.message = "Datos actualizados \n" + resp.message
      alert.status = "success"
    } else {
      alert.show = true
      alert.message = "Error al actualizar los datos"
      alert.status = "danger"
    }

    isSeting = false
  }

  const validarCaracteres = (clave) => {
    let re = /^(?=.*\d)(?=(.*[!*/#%@$_&-]){2,})(?=.*[a-z])(?=.*[A-Z]).{10,}$/
    return re.test(clave)
  }

  getDatos()

  onMount(() => {
    if (!$user) {
      navigate("/", { replace: true })
    }
  })
</script>

{#if $user}
  <Navbar />

  <div class="container-fluid py-3">
    <CardContent title="Cambiar contraseña">
      <form
        class="row g-2 align-items-center mb-2"
        on:submit|preventDefault={handleSubmit}
      >
        <div class="col-12 col-md-6 col-lg-3">
          <label for="razon_social">Cliente</label>
          <input
            type="text"
            id="razon_social"
            class="form-control"
            bind:value={usuario.razon_social}
            disabled
          />
        </div>
        <div class="col-12 col-md-6 col-lg-3">
          <label for="razon_social">Usuario</label>
          <input
            type="text"
            id="usuario"
            class="form-control"
            bind:value={usuario.usuario}
            disabled
          />
        </div>
        <div class="col-12 col-md-6 col-lg-3">
          <label for="clave">Contraseña</label>
          <input
            type="password"
            id="clave"
            class="form-control"
            bind:value={usuario.clave}
          />
        </div>
        <div
          class="col-12 col-md-6 col-lg-3 d-flex align-items-center gap-2 justify-content-between"
        >
          <div class="">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                bind:checked={send_sms}
                id="sms"
                disabled={option_sms}
              />
              <label class="form-check-label me-2" for="sms">
                Enviar SMS
                {#if usuario.celular != ""}
                  -
                  <span class="text-warning">
                    <i class="bi bi-envelope"></i>
                    {usuario.celular}
                  </span>
                {/if}
              </label>
            </div>

            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                bind:checked={send_correo}
                id="correo"
              />
              <label class="form-check-label me-2" for="correo">
                Enviar Correo
              </label>
            </div>
          </div>

          {#if isSeting}
            <button class="btn btn-primary" disabled>Guardando...</button>
          {:else}
            <button class="btn btn-primary">Guardar</button>
          {/if}
        </div>
      </form>
    </CardContent>
    <br />
    {#if alert.show}
      <Alert message={alert.message} status={alert.status} time={alert.time} />
    {/if}
  </div>
{/if}
